The identifier for the `JobCategory`.
